import React, { useState } from "react";

import Globals, { URLS } from "../../../utility/constants/appConstants";
import { amountFormatter } from "../../../utility/utils/formatter";
import { Link } from "react-router";

const EasyPay = (props) => {
  const [queryString, setQueryString] = useState(
    window.location.search != "" ? window.location.search : ""
  );
  const { payNow, amountDue, enrolledEP } = props.labels;
  const { dollars, cents } = amountFormatter(props.arBalance);

  const { paymentsCss, isActionEnabled } = props;
  return (
    <>
      <div
        className={`${paymentsCss["bg-white"]} col-12 col-md-4 col-lg-3 d-flex flex-column justify-content-end text-center text-lg-left p-0 ${paymentsCss["tru-mma-main-side"]}`}
      >
        <div className="align-items-center d-flex flex-column flex-fill justify-content-center p-10">
          <span
            className={`d-block ${paymentsCss["gfs-14"]} ${paymentsCss['gfw-3']} ${paymentsCss["gfs-lg-16"]}`}
          >
            {enrolledEP}
          </span>
          <span className={`d-block ${paymentsCss["gfs-10"]} ${paymentsCss["gfs-lg-14"]}`}>{amountDue} </span>
          <span
            className={`d-block ${paymentsCss["gfs-50"]} ${paymentsCss["gfs-md-26"]} ${paymentsCss["gfw-7"]}`}
          >
            <span>
              {Globals.currencySymbol}
              {dollars}
            </span>
            <sup className={`${paymentsCss["gfs-26"]} ${paymentsCss["gfs-md-16"]} margin-left`}>
              {cents}
            </sup>
          </span>
          <span className="d-block gfs-10 gfs-lg-14 text-center" />
        </div>
        <Link
          to={isActionEnabled?URLS.oneTime + queryString:""}
          className={`ShowLoadingModal ${paymentsCss["bg-yellow"]} ${paymentsCss["gfs-20"]} gfs-md-10 ${paymentsCss["gfs-lg-20"]} text-center ${paymentsCss["tru-mma-main-side-update"]} ${!isActionEnabled ? 'opacity-50 pe-none' : ''}`}
          style={{ fontSize: "20px", textDecoration: "none" }}
        >
          {payNow}
        </Link>
      </div>
    </>
  );
};

export default EasyPay;
